import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { MessageService } from 'src/app/services/message/message.service';
import { DomainConfigService } from 'src/app/services/translate/domain-config.service';
// import { LoadingScreenComponent } from "../../components/loading-screen/loading-screen.component";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  email = '';
  password = '';
  lang  = 'fr';
  confirmError = false;
  submitted = false;
  hide = true;
  error = '';
  activated = false;
  message = "Votre compte est en cours d'activation";
  messageEn = "Your account is being activated";
  token = '';
  
  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private domainConfig: DomainConfigService,
    ) { }

  Login() {
    this.messageService.getTranslate().subscribe((data) => {
      this.lang = data;
      if (this.lang == 'fr' && this.error == 'incorrect email / password') {
        this.error  = "email / mot de passe incorrect";
      }
      else if (this.lang == 'en' && this.error == 'email / mot de passe incorrect') {
        this.error = "incorrect email / password";
      }
    });

    this.authService.login( (this.email).toLowerCase(), this.password)
    .pipe( first() )
    .subscribe(
      data => {
        var userData = JSON.parse(localStorage.getItem('currentUser'));
        console.log("project: "+userData.comProject+ " subject :" +userData.comSubject)
        this.domainConfig.setConfig(userData.comProject, userData.comSubject);
        this.router.navigate(['/homes']);
        this.authService.obconnect.next(true);
      },
      err => {
        const error = err.error;
        const errorS = error.message;
        const errorD = error.detail;
        if (!errorD ) {
          this.error = (this.lang == 'fr' ? 'email / mot de passe incorrect' : 'incorrect email / password');
        } else if (!errorS) {
          this.error = errorD;
          this.confirmError = true;
        }
      }
    );
  }

  isIOS(): boolean {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
  }

  ngOnInit() {
    const idParam = this.route.snapshot.paramMap.get('ID');
    this.route.paramMap.subscribe(params => {
      var ID = params.get('ID');
      var specMsg = params.get('specMsg');
      var openmsg = params.get('openmsg');
      var idmsg = params.get('idmsg');
    });

    /*
    if(screenWidth < 480) {
        window.location.href = 'com.facework://';
        setTimeout(() => {
          // Vérifie si l'utilisateur est toujours sur la même page (l'application n'est pas installée)
          if (window.location.href.indexOf('com.facework') !== 0) {
            // Redirige vers le lien de téléchargement de l'App Store ou Google Play Store en fonction de la plateforme
            if (this.isIOS()) {
              window.location.href = 'https://apps.apple.com/fr/app/face2faces/id1557480419'; // Lien de l'App Store iOS
            } else {
              window.location.href = 'https://play.google.com/store/apps/details?id=com.facework'; // Lien du Google Play Store Android
            }
          }
        }, 2000);
    }*/
    if (this.authService.logIn) {
      this.router.navigate(['/homes']);
    }
    this.route.paramMap.subscribe(params => {
      if(params.get('token')){
        this.token = params.get('token').replace("https:","");
        this.activateAccount(this.token);
      }
    });
  }

  activateAccount(userToken){
    this.authService.confirm(userToken)
     .subscribe(
       data => {
         this.activated = true;
         if (this.lang == 'fr') {
           this.message = 'Votre compte est activé. Vous pouvez maintenant vous connectez.';
         }
         else if (this.lang == 'en') {
           this.messageEn = 'Your account is activated. You can now log in.';
         }
       },
       err => {
         this.message = "";
         //this.message = "Une erreur s'est produite";
         this.messageEn = '';
         //this.messageEn = 'An error has occurred';
 
         const error = err.error;
         const errorS = error.message;
         const errorD = error.detail;
         const errordescription = err.error['hydra:description'];
         if (errordescription) {
           this.error = errordescription;
         }
         else if (errorD){  
           this.error = JSON.stringify(errorD);
         }else if (errorS) {
           this.error = JSON.stringify(errorS);
         } else {
           this.error = JSON.stringify(error);
         }
       }
     );
   }

}
